// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Administrasjon',
    orders: 'Bestillinger',
    contents: 'Innhold'
}
